var $ab29dff56735387a$exports = {};
$ab29dff56735387a$exports = {
    "backButton": (args)=>`Wr\xf3\u{107} do: ${args.prevMenuButton}`,
    "moreActions": `Wi\u{119}cej akcji`,
    "unavailable": `Niedost\u{119}pne, rozwi\u{144}, aby zobaczy\u{107} szczeg\xf3\u{142}y`
};


export {$ab29dff56735387a$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
